import type { SVGProps } from 'react';

const SvgBriefcase = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M8 2a1 1 0 0 0-1 1v3H5a3 3 0 0 0-3 3v6h19.994L22 9.002A3 3 0 0 0 19 6h-2V3a1 1 0 0 0-1-1zm7 4V4H9v2zm-1.5 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      clipRule="evenodd"
    />
    <path fill={props.color} d="M21.993 17H2v2a3 3 0 0 0 3 3h13.991a3 3 0 0 0 3-2.998z" />
  </svg>
);

export default SvgBriefcase;
